let loading: Promise<any> | undefined;

function registerApache(monaco: any): void {
 if (monaco.languages.getLanguages().some((language: any) => language.id === 'apache')) return;
 monaco.languages.register({ id: 'apache', aliases: ['Apache2'], extensions: ['.conf'] });
 monaco.languages.setMonarchTokensProvider('apache', {
  ignoreCase: true,
  tokenizer: { root: [
   [/#.*$/, 'comment'],
   [/<\/?[a-z][\w]*/, 'tag'],
   [/>/, 'delimiter'],
   [/\{\{\s*[a-z_][\w]*\s*\}\}/, 'variable'],
   [/"[^"\r\n]*"|'[^'\r\n]*'/, 'string'],
   [/\$\{[^}]+\}|%\{[^}]+\}/, 'variable'],
   [/^(\s*)([a-z][\w]*)/, ['', 'keyword']],
   [/\b(?:on|off|all|none|deny|allow)\b/, 'keyword'],
   [/\b\d+(?:\.\d+)*\b/, 'number'],
  ] },
 });
 monaco.languages.setLanguageConfiguration('apache', {comments: {lineComment:'#'}, brackets:[['<','>']], autoClosingPairs:[{open:'"',close:'"'}]});
}

/** Load the pinned, same-origin editor and its workers only when an editor is opened. */
export function loadMonaco(): Promise<any> {
 if (!loading) loading = new Promise((resolve, reject) => {
  const browser = window as any;
  const start = () => {
   browser.require.config({ paths: { vs: '/assets/monaco/vs' } });
   browser.require(['vs/editor/editor.main'], () => { registerApache(browser.monaco); resolve(browser.monaco); }, reject);
  };
  if (browser.monaco?.editor) { registerApache(browser.monaco); resolve(browser.monaco); return; }
  if (browser.require?.config) { start(); return; }
  const script = document.createElement('script');
  script.src = '/assets/monaco/vs/loader.js';
  script.onload = start;
  script.onerror = () => { script.remove(); reject(new Error('편집기를 불러오지 못했습니다. 페이지를 새로고침해 주세요.')); };
  document.head.append(script);
 }).catch(error => { loading = undefined; throw error; });
 return loading;
}
